import Api from '@/services/Api'

// eIzvjestavanje - Fiskalizacija 2.0 preko ePoslovanje API v2.
// API kljuc se NE salje odavde; server ga cita iz Companies.eRacunProviderAPIkey
// te tvrtke. Kljuc poslan iz preglednika svatko moze zamijeniti.
export default {
  // dnevnik poslanih zahtjeva
  index (query) {
    return Api().get('eizvjestavanje', {
      params: query
    })
  },
  // racuni iz knjige, sa stanjem eIzvjestavanja
  racuni (query) {
    return Api().get('eizvjestavanje/racuni', {
      params: query
    })
  },
  // sto servis Porezne uprave zna o jednom racunu
  zahtjevi (query) {
    return Api().get('eizvjestavanje/zahtjevi', {
      params: query
    })
  },
  // je li tvrtka podesena (kljuc, testni/produkcijski server)
  postavke (query) {
    return Api().get('eizvjestavanje/postavke', {
      params: query
    })
  },
  // poslovne jedinice partnera (veliki kupci primaju racun na jedinicu)
  poslovnice (query) {
    return Api().get('eizvjestavanje/poslovnice', {params: query})
  },
  posalji (body) {
    return Api().post('eizvjestavanje/posalji', body)
  },
  // povlaci stanje sa servisa za sve racune razdoblja; jedan poziv po racunu,
  // pa zna potrajati
  sinkroniziraj (body) {
    return Api().post('eizvjestavanje/sinkroniziraj', body)
  }
}
